import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import WidgetTemplateCreate from './components/WidgetTemplateCreate/WidgetTemplateCreate';
import useWidgetTemplateCreate from './hooks/useWidgetTemplateCreate';

/**
 * Container component for creating widget templates
 * Manages mutation state and navigation, delegates rendering to WidgetTemplateCreate
 */
export default function WidgetTemplateCreateContainer() {
  const { loading, handleCancel, handleSubmit } = useWidgetTemplateCreate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  // Get breadcrumbs data
  const breadCrumbsData = getBreadCrumbsDataByKey({ pathname, t });

  return (
    <>
      <BreadCrumbs data={breadCrumbsData} />
      <WidgetTemplateCreate
        loading={loading}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    </>
  );
}
